import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({
    title = 'Travel with Ashan Beruwala Sri Lanka - Explore Sri Lanka',
    description = 'Explore Sri Lanka with Travel with Ashan Beruwala Sri Lanka. Discover tailor-made tour packages, breathtaking landscapes, rich cultural heritage, and unforgettable adventures.',
    keywords = 'Travel with Ashan, Sri Lanka Tours, Travel Sri Lanka, Tour Packages, Adventure Tours, Cultural Tours, Sri Lanka Vacation, Sri Lanka Holiday Packages, Sri Lanka Sightseeing, Wildlife Tours, Beach Getaways, Beruwala Tours, Sri Lanka Cultural Experiences, Ashan Travel',
    image = '%PUBLIC_URL%/logo.png',
    url = 'https://www.ashantours.com',
}) => {
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta name="author" content="Travel with Ashan Beruwala Sri Lanka" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:url" content={url} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
        </Helmet>
    );
};

export default SEO;